<template>
  <a-select
    :disabled="disabled"
    :multiple="false"
    :placeholder="placeholder"
    :value="value"
    allow-clear
    option-filter-prop="title"
    show-search
    @change="onChange"
  >
    <a-select-option v-for="item in records" :key="item.id" :title="item.name" :value="item.id">{{
      item.name
    }}</a-select-option>
  </a-select>
</template>

<script lang="ts">
import { TeamService } from "@/views/maintenance/team/team.service";
import { defineComponent, onMounted } from "vue";
import { onMountedOrActivated } from "@/core/hooks/onMountedOrActivated";
/**
 * 维保团队成员
 *
 * 使用方式:
 * <maintenance-team-select v-model:value="formRef.id"></maintenance-team-select>
 */
export default defineComponent({
  isGlobal: true,
  props: {
    value: {
      type: String,
      default: undefined,
    },

    disabled: {
      type: Boolean,
      default: false,
    },

    placeholder: {
      type: String,
      default: "请选择",
    },
    api: {
      type: String,
    },
    defaultValue: {
      type: String,
      default: undefined,
    },
  },
  emits: ["update:value", "change"],
  setup(props, { emit }) {
    const { data: records, run, loading } = TeamService.useSimpleListApi();
    const onChange = async (id) => {
      let user = ((records?.value || []) as Array<any>).find((r) => r.id == id);
      emit("update:value", id);
      emit("change", user);
    };
    onMountedOrActivated(async () => {
      await run();
      // console.log("🚀 ~ file: index.vue:65 ~ onMounted ~ records:", records);
      if (props.defaultValue) {
        let item = ((records?.value || []) as Array<any>).find(
          (r) => r.bizType == props.defaultValue
        );
        if (item) {
          emit("update:value", item.id);
          emit("change", item.id);
        }
      }
    });

    return {
      records,
      loading,
      onChange,
    };
  },
});
</script>
